import React from 'react'
import styled from 'react-emotion'
import { colors } from '../../styles'

export const UserIcon = styled('div')`
  border: 1px solid ${colors.tui_white};
  border-radius: 50%;
  color: ${props => props.active ? colors.tui_dark_blue : colors.tui_grey};
  background-color: ${props => props.active ? colors.tui_blue_25 : colors.tui_border};
  font-weight: bold;
  margin-right: -4px;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export default ({ lastName, firstName, leadPassenger, accepted, onClick }) => (
  <div>
    <UserIcon active={accepted || leadPassenger} onClick={onClick}>
      {firstName && firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()}
    </UserIcon>
  </div>
)